var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.document)?_c(_vm.isPdf(_vm.document) || _vm.document.preview_route ? 'PdfViewer' : 'DocumentPreview',{key:_vm.sequence,ref:"viewer",tag:"component",attrs:{"document":_vm.document},on:{"close":function($event){_vm.document = null}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }